module.exports = __webpack_public_path__ + "sn.svg?ef9279ad268d9c8a1345d5d3ab078b59";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sn.svg
// module id = 1131
// module chunks = 27